module.exports = __webpack_public_path__ + "img/parlient.cf32887e.webp";